export const ENDPOINTS_MAP = {
  'trovaAtm/getRegionList': {
    test: '/rest/v1/Eir/regions',
    local: './../assets/rest/v1/trovaAtm/regions.json',
    devDir: '/EirMng/rest/public/regionTerritory/V1/regions',
    // dev: '/digitalbank/EirMng/rest/public/regionTerritory/V1/regions',
    dev: './../assets/rest/v1/trovaAtm/regions.json',
    svil: '/digitalbank/EirMng/rest/public/regionTerritory/V1/regions'
  },
  'trovaAtm/searchAtmByCoords': {
    test: '/ATMMng/rest/public/atm/V1/coordsATMs',
    dev: '/digitalbank/ATMMng/rest/public/atm/V1/coordsATMs',
    local: '/rest/V1/trovaAtm/searchAtm',
    devDir: '/it/digitalbank-atm/v1/coordsATMs',
    svil: '/digitalbank/ATMMng/rest/atm/V1/coordsATMs'
  },
  'trovaAtm/searchAtmByProvince': {
    test: '/ATMMng/rest/public/atm/V1/provinceATMs',
    dev: '/digitalbank/ATMMng/rest/public/atm/V1/provinceATMs',
    local: '/CBSATMMngChnWAR/rest/public/atm-mng/province',
    devDir: '/it/digitalbank-atm/v1/provinceATMs',
    svil: '/digitalbank/ATMMng/rest/public/atm/V1/provinceATMs'
  },
  'trovaAtm/searchAtmByRegion': {
    test: '/ATMMng/rest/public/atm/V1/regionATMs',
    dev: '/digitalbank/ATMMng/rest/public/atm/V1/regionATMs',
    local: './../assets/rest/v1/trovaAtm/regionATMs.json',
    devDir: '/ATMMng/rest/public/atm/V1/regionATMs',
    svil: '/digitalbank/ATMMng/rest/public/atm/V1/regionATMs'
  },
  'trovaAtm/searchAgencyWithCurrentPosition': {
    test: '/rest/V1/trovaAtm/searchAgencyWithCurrentPosition',
    local: '/rest/V1/trovaAtm/searchAgencyWithCurrentPosition',
    dev: '/digitalbank/rest/V1/trovaAtm/searchAgencyWithCurrentPosition'
  },
  // 'trovaAtm/searchAtmWithCurrentPosition': {
  //   test: '/rest/V1/trovaAtm/searchAtmWithCurrentPosition',
  //   local: '/rest/V1/trovaAtm/searchAtmWithCurrentPosition',
  //   dev: '/digitalbank/rest/V1/trovaAtm/searchAtmWithCurrentPosition'
  // }
}